import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomFieldPolicyPermission, CustomFields } from '../../custom-fields.interface';
import {
  CUSTOM_FIELDS_STATUS_MAP,
  CUSTOM_FIELDS_TYPES_MAP,
  CUSTOM_FIELDS_TYPES,
  getBooleanFieldName,
  getDateFieldName,
} from '../../custom-fields.constants';
import { ComputedFrom } from '@certemy/common';
import { applyPhoneMask } from '@certemy/ui-components';
import { CUSTOM_FIELD_TYPES } from 'constants/constants';

@Component({
  selector: 'cm-template-custom-field',
  templateUrl: './template-custom-field.component.html',
  styleUrls: ['./template-custom-field.component.scss'],
})
export class TemplateCustomFieldComponent {
  @Input() policyPermissions: CustomFieldPolicyPermission;
  @Input() field: CustomFields.Field;
  @Output() onEdit = new EventEmitter();
  @Output() onDelete = new EventEmitter();

  @ComputedFrom('field')
  get fieldTypeName(): string {
    return CUSTOM_FIELDS_TYPES_MAP[this.field.type_id];
  }

  @ComputedFrom('field')
  get fieldStatusName(): string {
    return CUSTOM_FIELDS_STATUS_MAP[this.field.status_id];
  }

  @ComputedFrom('field')
  get fieldDefaultValue(): string {
    let value;
    switch (this.field.type_id) {
      case CUSTOM_FIELD_TYPES.BOOLEAN_SELECT:
        value = getBooleanFieldName(this.field.default_value);
        break;
      case CUSTOM_FIELD_TYPES.DATE:
        value = getDateFieldName(this.field.default_value);
        break;
      case CUSTOM_FIELD_TYPES.PHONE_NUMBER:
        value = applyPhoneMask(this.field.default_value);
        break;
      default:
        value = this.field.default_value;
        break;
    }
    return value || 'N/A';
  }

  onEditClick() {
    this.onEdit.emit();
  }

  onDeleteClick() {
    this.onDelete.emit();
  }
}
